import { removeTrapFocus, trapFocus } from '@theme/focus';

if (!window.drawerSearchPanelInitialized) {
  window.drawerSearchPanelInitialized = true;

  const searchDialog = document.getElementById('DrawerSearchPanel');
  searchDialog?.addEventListener('close', () => {
    if (searchDialog.dataset.openedFrom !== 'menu') return;

    const menuDrawer = document.querySelector('header-drawer.is-search-panel-open');
    menuDrawer?.classList.remove('is-search-panel-open');

    const menuDetails = document.getElementById('Details-menu-drawer-container');
    if (menuDetails instanceof HTMLDetailsElement && menuDetails.open) trapFocus(menuDetails);
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-side-search-open]');
    if (openButton) {
      event.preventDefault();
      const drawer = openButton.closest('header-drawer');
      if (drawer) {
        drawer.classList.add('is-search-panel-open');
        removeTrapFocus();
      }

      window.requestAnimationFrame(() => {
        const dialog = document.getElementById('DrawerSearchPanel');
        if (dialog instanceof HTMLDialogElement) {
          dialog.dataset.openedFrom = drawer ? 'menu' : 'header';
          dialog.showModal();
          dialog.querySelector('[data-side-search-input]')?.focus();
        }
      });
      return;
    }

    const closeButton = event.target.closest('[data-side-search-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const menuButton = event.target.closest('[data-side-search-menu]');
    if (menuButton) {
      menuButton.closest('dialog')?.close();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.id === 'DrawerSearchPanel') {
      event.target.close();
    }
  });
}
